function resize() {
    console.log(222)
    // 系统整体缩放
    let cliWidth = document.documentElement.clientWidth || document.body.clientWidth
    let cliHeight = document.documentElement.clientHeight || document.body.clientHeight
    console.log('屏幕宽度1：' + cliWidth)
    console.log('屏幕宽度2：' + window.innerWidth)
    let contW = 1920
    let contH = 1080
    let w = cliWidth / contW
    let h = cliHeight / contH
    console.log('屏幕宽度3：' + w)
    console.log('屏幕宽度4：' + h)
    let appDom = document.querySelector('#app')
    let size = cliWidth / cliHeight
    console.log("11113213weqweqw")
     if (cliWidth < 1256 ) {
      console.log("dhsbshdfhvbhsdf")
      if (w > h) {
        appDom.style.transform = 'scale(' + h + ')'
      } else {
        appDom.style.transform = 'scale(' + w + ')'
      }
      appDom.style.transformOrigin = 'top left'
      appDom.style.width = cliWidth + 'px'
      appDom.style.height = cliHeight + 'px'
     }else{
      // appDom.style.transform = 'scale(' + w+ ')'
     }

    
  }
  resize();
  window.onresize = function () {
    console.log(111)
    resize();
  }